import { request } from '../../utils'

// The `/api/comment/*` endpoints below are still on API v1, which only returns
// JSON when explicitly asked via `format=json&raw=1`. The new fetch layer no
// longer injects those, so we pass them here until these calls move to
// `/api/2/...`. The `/api/2/comment/*` calls are already v2 and only need an
// explicit method (the old layer defaulted to POST).
const V1_JSON = { format: 'json', raw: '1' }

export const fetchComments = (liveId, commentType, options = {}, page = 1) => {
  const url = '/api/comment/list'

  return request({
    url,
    method: 'GET',
    data: {
      object_id: liveId,
      comment_type: commentType,
      p: page,
      size: options.size || 40,
      presenter_token: options.presenterToken,
      order: options.order,
      ...V1_JSON,
    },
  })
}

export const fetchComment = (commentId, liveId, presenterToken) => {
  const url = '/api/comment/list'

  return request({
    url,
    method: 'GET',
    data: {
      object_id: liveId,
      comment_id: commentId,
      presenter_token: presenterToken,
      ...V1_JSON,
    },
  })
}

export const getLiveRealtimeData = (liveId) => {
  const url = '/api/comment/list'

  return request({
    url,
    method: 'GET',
    data: {
      object_id: liveId,
      include_realtime_p: 1,
      size: 0,
      ...V1_JSON,
    },
  })
}

export const addComment = (
  liveId,
  token,
  content,
  commentType,
  userInfo = {}
) => {
  const url = '/api/comment/add'
  return request({
    url,
    method: 'POST',
    data: {
      object_id: liveId,
      object_token: token,
      content,
      object_type: 'live',
      comment_type: commentType,
      name: userInfo.name,
      uuid: userInfo.uuid,
      ...V1_JSON,
    },
  })
}

export const deleteComment = (liveId, commentId) => {
  const url = '/api/comment/delete'

  return request({
    url,
    method: 'POST',
    data: {
      live_id: liveId,
      comment_id: commentId,
      ...V1_JSON,
    },
  })
}

export const updateComment = (liveId, commentId, status) => {
  const url = '/api/2/comment/update'

  return request({
    url,
    method: 'POST',
    data: {
      object_id: liveId,
      comment_id: commentId,
      comment_status: status,
    },
  })
}

export const postCommentSetOrder = (liveId, comments) => {
  const url = '/api/2/comment/set-order'
  const order = comments.map((comment) => comment.comment_id).join(',')

  return request({
    url,
    method: 'POST',
    data: {
      object_id: liveId,
      order,
    },
  })
}
